import { render } from "./myMenu.vue?vue&type=template&id=5b4ab282&scoped=true"
import script from "./myMenu.vue?vue&type=script&lang=js"
export * from "./myMenu.vue?vue&type=script&lang=js"

import "./myMenu.vue?vue&type=style&index=0&id=5b4ab282&lang=scss&scoped=true"

import exportComponent from "E:\\Gitlab\\02_各园区PC端\\happyHarbour\\ningbo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4ab282"]])

export default __exports__